import type { Estates } from '@/features/estates/api/estates';
import type { Projects } from '@/features/projects/api/projects';

type EstateAreaRooms =
  | { areaRooms?: Projects[number]['areaRooms'] }
  | { estateAreasRooms?: Estates[number]['estateAreasRooms'] }
  | null
  | undefined;

export const getFinalAreaRoom = (estate: EstateAreaRooms) => {
  if (!estate) return '-';
  if ('areaRooms' in estate && estate.areaRooms) {
    const { min, max } = estate.areaRooms.usageArea;
    if (min !== null && max !== null) {
      return `${min} - ${max}`;
    }
    return min ?? max ?? '-';
  }
  if ('estateAreasRooms' in estate && estate.estateAreasRooms) {
    return estate.estateAreasRooms?.totalNumberOfRooms;
  }
  return '-';
};
